var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-field',{attrs:{"label":_vm.label}},[_c('q-input-frame',{attrs:{"color":_vm.color}},[_c('q-icon',{attrs:{"name":"info","size":"2.2em","color":this.value.length ? 'red' : 'highlight'}})],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be5d1de0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VMinimumStockAlert.vue
// module id = mJyN
// module chunks = 83